import { render, staticRenderFns } from "./ProspectList.vue?vue&type=template&id=16f673f8"
import script from "./ProspectList.vue?vue&type=script&lang=ts"
export * from "./ProspectList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports